export const GridItemSkeleton = () => (
  <div className="animate-pulse h-full w-full bg-cool-gray-800" />
)
